import UrlGeneration from '../urlGeneration';

export default class FilterPrice {
  constructor() {
    this.sFiledName = 'price';

    this.sInputMinPriceName = 'filter-min-price';
    this.sInputMaxPriceName = 'filter-max-price';

    this.sInputSelector = `data-filter-price`;

    this.iCallBackDelay = 400;
  }

  /**
   * Init event handlers
   */
  run() {
    UrlGeneration.init();
    this.prepareRequestData();
    UrlGeneration.update();
  }

  prepareRequestData() {
    // Get min price from filter input
    const obInputList = document.querySelector(`${this.sInputSelector}`);
    if (!obInputList) {
      return;
    }
    const obMinInput = obInputList.querySelector(`[name=${this.sInputMinPriceName}]`);
    const obMaxInput = obInputList.querySelector(`[name=${this.sInputMaxPriceName}]`);

    const sMinAttr = obMinInput.getAttribute('min').replace(/\s/g,'');
    const sMaxAttr = obMaxInput.getAttribute('max').replace(/\s/g,'');

    const fMinLimit = parseFloat(sMinAttr);
    const fMaxLimit = parseFloat(sMaxAttr);

    if (fMinPrice > 0 && fMinPrice < fMinLimit) {
      fMinPrice = fMinLimit;
      obMinInput.value = fMinLimit;
    }

    if (fMaxPrice > 0 && fMaxPrice > fMaxLimit) {
      fMaxPrice = fMaxLimit;
      obMaxInput.value = fMaxLimit;
    }

    if (fMinPrice === 0 && fMaxPrice === 0) {
      UrlGeneration.remove(this.sFiledName);
    } else {
      UrlGeneration.set(this.sFiledName, [fMinPrice, fMaxPrice]);
    }
  }

  /**
   * Redeclare default selector of filter input
   * Default value is "_shopaholic-price-filter"
   *
   * @param {string} sInputSelector
   * @returns {ShopaholicFilterPrice}
   */
  setInputSelector(sInputSelector) {
    this.sInputSelector = sInputSelector;

    return this;
  }

  /**
   * Redeclare default input name with min price
   * Default value is "filter-min-price"
   *
   * @param {string} sInputName
   * @returns {ShopaholicFilterPrice}
   */
  setInputMinPriceName(sInputName) {
    this.sInputMinPriceName = sInputName;

    return this;
  }

  /**
   * Redeclare default input name with max price
   * Default value is "filter-max-price"
   *
   * @param {string} sInputName
   * @returns {ShopaholicFilterPrice}
   */
  setInputMaxPriceName(sInputName) {
    this.sInputMaxPriceName = sInputName;

    return this;
  }

  /**
   * Redeclare default URL filed name
   * Default value is "price"
   *
   * @param {string} sFieldName
   * @returns {ShopaholicFilterPrice}
   */
  setFieldName(sFieldName) {
    this.sFiledName = sFieldName;

    return this;
  }
}
